import PTimePicker from './picker/time-picker';
import PDatePicker from './picker/date-picker';
/* istanbul ignore next */
PTimePicker.install = function(Vue) {
  Vue.component(PTimePicker.name, PTimePicker);
};

PDatePicker.install = function(Vue) {
  Vue.component(PDatePicker.name, PDatePicker);
};

export default PDatePicker;
export { PTimePicker, PDatePicker };
